import { Theme } from "@amx/ux-twoui-theming";
import { twouiZIndexes } from "@amx/ux-twoui-utils";
import { IButtonStyles } from "@fluentui/react";

export const getButtonStyles = (theme: Theme): IButtonStyles => {
    return {
        root: {
            position: "fixed",
            // This x-axis translation is used to move the bypass blocks button out of the page view,
            // since it should only be visible when the user tabs to it.
            transform: "translateX(-100%)",
            zIndex: twouiZIndexes.twoUILeftNavBypassBlocksButton,
            fontWeight: 600,
            backgroundColor: theme.palette.neutralPrimary,
            borderColor: theme.palette.neutralPrimary,
            selectors: {
                ":focus": {
                    // This x-axis translation brings the bypass blocks button in the page view.
                    transform: "translateX(0%)",
                    background: theme.palette.neutralPrimary,
                    borderColor: theme.palette.neutralPrimary,
                    selectors: {
                        ":hover": {
                            transform: "translateX(0%)",
                            background: theme.palette.neutralSecondary,
                            borderColor: theme.palette.neutralSecondary
                        },
                        ":active": {
                            transform: "translateX(0%)",
                            background: theme.palette.neutralDark,
                            borderColor: theme.palette.neutralDark
                        },
                    }
                }
            }
        }
    };
};
